<div class="row mt-3 mb-3">
  <div class="col-3">
    <button (click)="adicionarRetencao()" #btnAdicionarRetencao class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar retenção
    </button>
  </div>
  <div class="col-9 text-right font-weight-bold">
    <span *ngIf="listaRetencoes && listaRetencoes.length > 0">TOTAL RETIDO: {{totalRetido | number:'1.2-2' }}</span>
  </div>
</div>
<table class="table table-eddy" *ngIf="listaRetencoes && listaRetencoes.length > 0">
  <thead>
    <tr>
      <th scope="col">Vencimento</th>
      <th scope="col">Ficha retenção</th>
      <th scope="col">Valor</th>
      <th scope="col">CEI</th>
      <th scope="col">GPS</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaRetencoes; let idx = index">
      <td *ngIf="!item.editavel" style="width: 200px">{{item.data_vencimento | date:'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel" style="width: 40%">{{item.ficha.numero}} - {{item.ficha.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 200px">{{item.valor_retido | number:'1.2-2'}}</td>
      <td *ngIf="!item.editavel" style="width: 150px">{{item.cei}}</td>
      <td *ngIf="!item.editavel" style="width: 150px">{{item.gps}}</td>

      <td *ngIf="item.editavel" style="width: 200px">
        <p-calendar id="data_vencto" [(ngModel)]="entity.data_vencimento" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel" style="width: 40%">
        <div class="col-2 p-0 float-left">
          <input class="form-control form-control-sm" type="text"
            (blur)="fichaAutoComplete.atualizar(false, {ngModel: entity, field: 'ficha'})"
            [(ngModel)]="fichaAutoComplete.id" name="ficha_id" [ngModelOptions]="{standalone: true}"
            *ngIf="fichaAutoComplete" />
        </div>
        <div class="col-10 p-0 float-right">
          <p-autoComplete id="fic" [(ngModel)]="entity.ficha" [forceSelection]="true"
            (onBlur)="fichaAutoComplete.atualizar(true, {ngModel: entity, field: 'ficha'})" [autoHighlight]="true"
            [ngModelOptions]="{standalone: true}" [field]="fichaAutoComplete.conversor"
            [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
            inputStyleClass="form-control form-control-sm" minLength="1" [style]="{ width: '100%' }"
            *ngIf="fichaAutoComplete">
            <ng-template let-ficha pTemplate="item">
              {{ficha.numero}} {{ficha.nome}}
            </ng-template>
          </p-autoComplete>
        </div>
      </td>
      <td *ngIf="item.editavel" style="width: 200px">
        <input [(ngModel)]="entity.valor_retido" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="typed" [imask]="imaskConfig" id="valor_retido"
          placeholder="0,00">
      </td>
      <td *ngIf="item.editavel" style="width: 150px">
        <input [(ngModel)]="entity.cei" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="cei">
      </td>
      <td *ngIf="item.editavel" style="width: 150px">
        <input [(ngModel)]="entity.gps" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="gps">
      </td>
      <td class="text-right" style="min-width: 150px;">
        <button *ngIf="item.editavel" (click)="salvarRetencao(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelarRetencao(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" #btnsEditar (click)="editarRetencao(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>